import React from "react";

import InsertImageContainer from "@/components/business/InsertImageContainer/InsertImageContainer";
import DeletedPressBoundary from "@/components/shared/business/DeletedPressBoundary/DeletedPressBoundary";
import { useSafeLeavePage } from "@hooks/useSafeLeavePage";

const InsertImagePage = () => {
  useSafeLeavePage();

  return (
    <DeletedPressBoundary>
      <InsertImageContainer />
    </DeletedPressBoundary>
  );
};

export default InsertImagePage;
